import axios from '@js/clients/axios';

function vehicleYears(min, max) {
  return Array.from(new Array(max - min + 1), (item, index) => ({
    label: String(min + index),
    value: String(min + index),
  }));
}

export function vehicleFindCallback(FIELDS, props, planter) {
  const {
    leaves,
    values,
    properties,
  } = planter;

  const value = values.value[FIELDS.NAME];
  const names = {};

  const manufactureOptions = properties.value[FIELDS.MANUFACTURE]?.options;
  const modelOptions = properties.value[FIELDS.MODEL]?.options;

  const identifier = values.value[FIELDS.IDENTIFIER];
  const manufacture = values.value[FIELDS.MANUFACTURE];
  const model = values.value[FIELDS.MODEL];

  if (manufactureOptions?.length && !manufactureOptions?.some((i) => i.value === manufacture)) {
    names[FIELDS.MANUFACTURE] = '';
  }

  if (modelOptions?.length && !modelOptions?.some((i) => i.value === model)) {
    names[FIELDS.IDENTIFIER] = '';
  }

  const vehicle = props.domains.grouped_vehicle_model.find((i) => i.label === value);

  function success(response) {
    leaves.value[FIELDS.IDENTIFIER].options = response
      .data
      .vehicle_models
      .filter((i) => vehicle.name === i.name && model >= i.year_start && model <= i.year_end)
      .map((i) => ({
        label: `${i.name} - ${i.version} - ${i.fuel.name}`,
        value: i.id,
      }));

    if (
      !identifier
      || planter.properties.value[FIELDS.IDENTIFIER].options.some((i) => i.value === identifier)
    ) {
      return {};
    }

    return {
      [FIELDS.IDENTIFIER]: '',
    };
  }

  function failure(error) {
    /* eslint-disable no-console */
    console.log('VECHILES/SEARCH FAILURE');
    console.error(error);
    /* eslint-enable no-console */

    leaves.value[FIELDS.IDENTIFIER].options = [];

    return {
      [FIELDS.IDENTIFIER]: '',
    };
  }

  if (vehicle && model && manufacture) {
    const data = {
      params: {
        name: vehicle.name,
        vehicle_brand_id: vehicle.vehicle_brand.id,
        per_page: 99999,
      },
    };

    return {
      loading: [FIELDS.IDENTIFIER],
      promise: axios
        .get('/vehicle_models', data)
        .then(success)
        .catch(failure),
    };
  }

  if (leaves.value[FIELDS.IDENTIFIER]) {
    leaves.value[FIELDS.IDENTIFIER].options = [];
  }

  return names;
}

export function vehicleNameCallback(FIELDS, props, planter, name, __value, retries = 0) {
  const {
    leaves,
    values,
  } = planter;

  const manufacture = leaves.value[FIELDS.MANUFACTURE];
  const model = leaves.value[FIELDS.MODEL];

  if ((!manufacture || !model) && retries < 10) {
    setTimeout(
      vehicleNameCallback.bind(null, FIELDS, props, planter, name, __value, retries + 1),
      10,
    );
  }

  const value = values.value[name];
  const vehicle = props.domains.grouped_vehicle_model.find((i) => i.label === value);

  const {
    year_start: start,
    year_end: end,
  } = vehicle || {};

  if (manufacture) {
    manufacture.options = vehicle
      ? vehicleYears(start, Math.min(end, new Date().getFullYear()))
      : [];
  }

  if (model) {
    model.options = vehicle ? vehicleYears(start, end) : [];
  }

  return vehicleFindCallback(FIELDS, props, planter, name);
}
